'use strict';

exports.__esModule = true;
exports.getAvailableServices = exports.search = exports.ACTIONS = undefined;
exports.setShowResults = setShowResults;
exports.setRecentQueries = setRecentQueries;
exports.addToRecentQueries = addToRecentQueries;
exports.getRecentQueriesFromLocalStorage = getRecentQueriesFromLocalStorage;
exports.setUserId = setUserId;
exports.getUser = getUser;
exports.setAllResults = setAllResults;
exports.setMarketplaceResults = setMarketplaceResults;
exports.setAppResults = setAppResults;
exports.setServiceResults = setServiceResults;
exports.setContentTypeResults = setContentTypeResults;
exports.setSuggestResults = setSuggestResults;
exports.setAutocompleteResults = setAutocompleteResults;
exports.setFilterValue = setFilterValue;
exports.setSearchQuery = setSearchQuery;
exports.configureUserState = configureUserState;
exports.setResultHighlight = setResultHighlight;
exports.setResultSelection = setResultSelection;
exports.executeSearch = executeSearch;

var _search = require('../services/search');

var SearchProvider = _interopRequireWildcard(_search);

var _services = require('../services/services');

var _users = require('../services/users');

var _storage = require('../services/storage');

var _capability = require('../constants/capability');

var _capability2 = _interopRequireDefault(_capability);

var _filter = require('../constants/filter');

var _filter2 = _interopRequireDefault(_filter);

var _appsmartIdentity = require('../constants/appsmart-identity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var MIN_QUERY_LENGTH = 1;
var MAX_RECENT_QUERIES_LENGTH = 100;
var RECENT_QUERIES = 'RecentQueries';

var debounce = function debounce(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var timeoutId = void 0;
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
            return fn.apply(undefined, args);
        }, delay);
    };
};

var isFilteredQuery = function isFilteredQuery(query) {
    return (/^(\S+) in (\S+)/.test(query)
    );
};

var isValidQuery = function isValidQuery(query) {
    return query && query.length >= MIN_QUERY_LENGTH;
};

var ACTIONS = exports.ACTIONS = {
    SET_FILTER_VALUE: 'SET_FILTER_VALUE',
    SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
    SET_SHOW_RESULTS: 'SET_SHOW_RESULTS',
    SET_ALL_RESULTS: 'SET_ALL_RESULTS',
    SET_MARKETPLACE_RESULTS: 'SET_MARKETPLACE_RESULTS',
    SET_APP_RESULTS: 'SET_APP_RESULTS',
    SET_SERVICE_RESULTS: 'SET_SERVICE_RESULTS',
    SET_CONTENT_TYPE_RESULTS: 'SET_CONTENT_TYPE_RESULTS',
    SET_SUGGEST_RESULTS: 'SET_SUGGEST_RESULTS',
    SET_RECENT_QUERIES: 'SET_RECENT_QUERIES',
    SET_CAPABILITIES: 'SET_CAPABILITIES',
    SET_SERVICES: 'SET_SERVICES',
    SET_SAVED_QUERY: 'SET_SAVED_QUERY',
    SET_RESULT_HIGHLIGHT: 'SET_RESULT_HIGHLIGHT',
    SET_RESULT_SELECTION: 'SELECT_RESULT',
    SET_AUTOCOMPLETE_RESULTS: 'SET_AUTOCOMPLETE_RESULTS',
    SET_USER_ID: 'SET_USER_ID'
};

function setShowResults(show) {
    return function (dispatch, getState) {
        var _getState = getState(),
            searchQuery = _getState.searchQuery,
            recentQueries = _getState.recentQueries,
            filterValue = _getState.filterValue;

        if (show && (isValidQuery(searchQuery) || filterValue === _filter2.default.ALL && recentQueries.length > 0)) {
            dispatch({
                type: ACTIONS.SET_SHOW_RESULTS,
                show: true
            });
        } else {
            dispatch({
                type: ACTIONS.SET_SHOW_RESULTS,
                show: false
            });
        }
    };
}

function setRecentQueries(results) {
    return function (dispatch, getState) {
        dispatch({
            type: ACTIONS.SET_RECENT_QUERIES,
            results: results
        });

        var _getState2 = getState(),
            userId = _getState2.userId;
        // Set recent queries of logged in user on local storage


        if (userId) {
            var recentQueries = (0, _storage.getItem)(RECENT_QUERIES) || {};
            recentQueries[userId] = results;
            (0, _storage.setItem)(RECENT_QUERIES, recentQueries);
        }
    };
}

function addToRecentQueries(searchQuery) {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            recentQueries = _getState3.recentQueries;

        var results = [].concat(recentQueries);
        var trimmedSearchQuery = searchQuery.trim();

        if (trimmedSearchQuery) {
            var index = results.findIndex(function (result) {
                return result.trim().toLowerCase() === trimmedSearchQuery.toLowerCase();
            });
            while (index > -1) {
                results.splice(index, 1);
                index = results.findIndex(function (result) {
                    return result.trim().toLowerCase() === trimmedSearchQuery.toLowerCase();
                });
            }

            results.unshift(trimmedSearchQuery);
            while (results.length > MAX_RECENT_QUERIES_LENGTH) {
                results.pop();
            }
        }

        dispatch(setRecentQueries(results));
    };
}

function getRecentQueriesFromLocalStorage() {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            userId = _getState4.userId;

        if (userId) {
            var recentQueries = (0, _storage.getItem)(RECENT_QUERIES) || {};

            if (recentQueries[userId]) {
                dispatch({
                    type: ACTIONS.SET_RECENT_QUERIES,
                    results: recentQueries[userId]
                });
            }
        }
    };
}

function setUserId(userId) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_USER_ID,
            userId: userId
        });
    };
}

function getUser() {
    return function (dispatch) {
        return (0, _users.fetchUser)().then(function (data) {
            var userId = data.id;
            dispatch(setUserId(userId));
        });
    };
}

function setAllResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_ALL_RESULTS,
            results: results
        });
    };
}

function setMarketplaceResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_MARKETPLACE_RESULTS,
            results: results
        });
    };
}

function setAppResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_APP_RESULTS,
            results: results
        });
    };
}

function setServiceResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_SERVICE_RESULTS,
            results: results
        });
    };
}

function setContentTypeResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_CONTENT_TYPE_RESULTS,
            results: results
        });
    };
}

function setSuggestResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_SUGGEST_RESULTS,
            results: results
        });
    };
}

function setAutocompleteResults(results) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_AUTOCOMPLETE_RESULTS,
            results: results
        });
    };
}

// Clear dropdown results (search, autocomplete or facets) irrelevant to the currently selected filter value
var clearIrrelevantDropdownResults = function clearIrrelevantDropdownResults(dispatch, filterValue) {
    if (filterValue !== _filter2.default.ALL) {
        dispatch(setAutocompleteResults([]));
        dispatch(setAllResults([]));
        dispatch(setServiceResults([]));
        dispatch(setContentTypeResults([]));
    }

    if (filterValue !== _filter2.default.MARKETPLACE && filterValue !== _filter2.default.PROVIDERS && filterValue !== _filter2.default.ADVISORS) {
        dispatch(setMarketplaceResults([]));
    }
};

var searchAll = debounce(function (dispatch, getState, searchQuery) {
    if (!isValidQuery(searchQuery) || isFilteredQuery(searchQuery)) {
        dispatch(setAllResults([]));
        return;
    }

    SearchProvider.searchAll(searchQuery).then(function (response) {
        if (getState().searchQuery === searchQuery) {
            dispatch(setAllResults(response));
        }
    });
});

var searchMarketplace = debounce(function (dispatch, getState, searchQuery) {
    if (!isValidQuery(searchQuery) || isFilteredQuery(searchQuery)) {
        dispatch(setMarketplaceResults([]));
        return;
    }

    SearchProvider.searchMarketplace(searchQuery).then(function (response) {
        if (getState().searchQuery === searchQuery) {
            dispatch(setMarketplaceResults(response));
        }
    });
});

var searchProviders = debounce(function (dispatch, getState, searchQuery) {
    if (!isValidQuery(searchQuery) || isFilteredQuery(searchQuery)) {
        dispatch(setMarketplaceResults([]));
        return;
    }

    SearchProvider.searchProviders(searchQuery).then(function (response) {
        if (getState().searchQuery === searchQuery) {
            dispatch(setMarketplaceResults(response));
        }
    });
});

var searchAdvisors = debounce(function (dispatch, getState, searchQuery) {
    if (!isValidQuery(searchQuery) || isFilteredQuery(searchQuery)) {
        dispatch(setMarketplaceResults([]));
        return;
    }

    SearchProvider.searchAdvisors(searchQuery).then(function (response) {
        if (getState().searchQuery === searchQuery) {
            dispatch(setMarketplaceResults(response));
        }
    });
});

var searchFacetSuggest = debounce(function (dispatch, getState, searchQuery, contentType) {
    // Queries searching within a specific contentType or service should not show facet results.
    // TODO: Use a better regex to detect queries formed as `"x" in y`
    if (!isValidQuery(searchQuery) || isFilteredQuery(searchQuery)) {
        dispatch(setServiceResults([]));
        dispatch(setContentTypeResults([]));
        return;
    }

    SearchProvider.searchFacetSuggest(searchQuery, contentType).then(function (_ref) {
        var sources = _ref.sources,
            contentTypes = _ref.contentTypes;

        if (getState().searchQuery === searchQuery) {
            var services = sources.map(function (source) {
                var serviceLookup = getState().serviceLookup;
                var label = serviceLookup && serviceLookup[source.type] ? serviceLookup[source.type].name : source.type;

                return Object.assign({}, source, {
                    label: label
                });
            });

            dispatch(setServiceResults(services));
            dispatch(setContentTypeResults(contentTypes));
        }
    });
});

var searchAutocomplete = debounce(function (dispatch, getState, searchQuery) {
    if (!isValidQuery(searchQuery)) {
        dispatch(setAutocompleteResults([]));
        return;
    }

    var _getState5 = getState(),
        filterValue = _getState5.filterValue;

    if (filterValue === _filter2.default.ALL) {
        SearchProvider.searchAutocomplete(searchQuery).then(function (response) {
            if (getState().searchQuery === searchQuery) {
                dispatch(setAutocompleteResults(response));
            }
        });
    } else if (filterValue === _filter2.default.MARKETPLACE || filterValue === _filter2.default.PROVIDERS || filterValue === _filter2.default.ADVISORS) {
        SearchProvider.searchAutocompleteMarketplace(searchQuery).then(function (response) {
            if (getState().searchQuery === searchQuery) {
                dispatch(setAutocompleteResults(response));
            }
        });
    }
});

var search = exports.search = function search() {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            filterValue = _getState6.filterValue,
            searchQuery = _getState6.searchQuery;

        // save query for result selection use


        dispatch({
            type: ACTIONS.SET_SAVED_QUERY,
            savedQuery: searchQuery
        });
        dispatch({
            type: ACTIONS.SET_RESULT_HIGHLIGHT,
            index: -1
        });

        // Dropdown results related to the filter will not be cleared. Instead, they will be kept until a new search
        // is made, and only then will those results update accordingly.
        clearIrrelevantDropdownResults(dispatch, filterValue);

        if (filterValue === _filter2.default.ALL) {
            searchAutocomplete(dispatch, getState, searchQuery);
            searchAll(dispatch, getState, searchQuery);
            searchFacetSuggest(dispatch, getState, searchQuery);
        } else if (filterValue === _filter2.default.MARKETPLACE) {
            searchMarketplace(dispatch, getState, searchQuery);
        } else if (filterValue === _filter2.default.PROVIDERS) {
            searchProviders(dispatch, getState, searchQuery);
        } else if (filterValue === _filter2.default.ADVISORS) {
            searchAdvisors(dispatch, getState, searchQuery);
        }
    };
};

function setFilterValue(value) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_FILTER_VALUE,
            filterValue: value
        });
        dispatch(search());
    };
}

function setSearchQuery(searchQuery) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_SEARCH_QUERY,
            searchQuery: searchQuery
        });
        dispatch(search());
    };
}

function configureUserState(config) {
    return function (dispatch) {
        // Only users wth valid capabilities will change filter options (e.g. appwise|appinsights)
        var capabilities = config.capabilities.filter(function (capability) {
            return Object.values(_capability2.default).includes(capability);
        });
        if (!capabilities.length) {
            return;
        }

        dispatch({
            type: ACTIONS.SET_CAPABILITIES,
            capabilities: capabilities
        });

        if (config.defaultFilter && Object.values(_filter2.default).includes(config.defaultFilter)) {
            dispatch(setFilterValue(config.defaultFilter));
        } else {
            dispatch(setFilterValue(_filter2.default.ALL));
        }
    };
}

var getAvailableServices = exports.getAvailableServices = function getAvailableServices() {
    return function (dispatch) {
        (0, _services.fetchAvailableServices)().then(function (data) {
            var services = data.results.reduce(function (acc, service) {
                var serviceIdentifier = service.marketplace_product_uuid ? service.marketplace_product_uuid : service.name;
                acc[serviceIdentifier] = {
                    name: service.pretty_name,
                    iconUrl: service.marketplace_product_uuid ? service.icon_url || service.logo_url : null
                };
                return acc;
            }, {});

            // We are renaming some of the filters pretty name
            services.appdirect_messenger = 'Messenger';
            services.appdirect_marketplace = 'Marketplace';
            services.appdirect_directory = 'Directory';

            dispatch({
                type: ACTIONS.SET_SERVICES,
                services: services
            });
        });
    };
};

function setResultHighlight(index) {
    return function (dispatch) {
        dispatch({
            type: ACTIONS.SET_RESULT_HIGHLIGHT,
            index: index
        });
    };
}

function setResultSelection(query, url) {
    return function (dispatch) {
        // set query in search bar without triggering search
        dispatch({
            type: ACTIONS.SET_SEARCH_QUERY,
            searchQuery: query
        });

        // set url for selected results with external links
        dispatch({
            type: ACTIONS.SET_RESULT_SELECTION,
            url: url
        });
    };
}

function executeSearch(query, searchFns) {
    var _onSearch;

    var onSearch = (_onSearch = {}, _onSearch[_filter2.default.MARKETPLACE] = searchFns.onSearchMarketplace, _onSearch[_filter2.default.ALL] = searchFns.onSearchQuery, _onSearch);

    if ((0, _appsmartIdentity.isAppSmart)()) {
        onSearch[_filter2.default.MARKETPLACE] = function (_ref2) {
            var detail = _ref2.detail;

            // Multiple 'pl' query parameters
            location.href = '/en-US/listing?q=' + encodeURIComponent(detail) + ((0, _appsmartIdentity.getMarketplaceProductLines)() || []).map(function (pl) {
                return '&pl=' + pl;
            }).join('');
        };
        onSearch[_filter2.default.PROVIDERS] = function (_ref3) {
            var detail = _ref3.detail;

            location.href = '/en-US/listing?q=' + encodeURIComponent(detail) + '&pl=' + (0, _appsmartIdentity.getProvidersProductLine)();
        };
        onSearch[_filter2.default.ADVISORS] = function (_ref4) {
            var detail = _ref4.detail;

            location.href = '/en-US/listing?q=' + encodeURIComponent(detail) + '&pl=' + (0, _appsmartIdentity.getAdvisorsProductLine)();
        };
    }

    return function (dispatch, getState) {
        var _getState7 = getState(),
            searchQuery = _getState7.searchQuery,
            filterValue = _getState7.filterValue;

        var input = {
            detail: query || searchQuery
        };

        onSearch[filterValue](input);
    };
}